import React, { useState } from 'react'
import './App.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Home from './Home'
import UserForm from './UserForm'
import GameApp from './GameApp'
import { useAuthState } from 'react-firebase-hooks/auth'
import { auth } from './firebase'

import Connection from './Connection';

import { Web3ReactProvider } from '@web3-react/core'
import Web3 from 'web3'

import { LoginContext } from './Contexts/LoginContext.js';


function getLibrary(provider) {
  return new Web3(provider)
}



export default function App() {
  const [user, loading, error] = useAuthState(auth)

  const [memberPiece, setMemberPiece] = useState(); 
  const [currUserPiece, setCurrUserPiece] = useState(); 
  const [isStaked, setIsStaked] = useState("false");
  const [isGameOver, setIsGameOver] = useState()

  if (loading) {
      return 'loading ...'
  }
  if (error) {
      return 'There was an error'
  }
  if (!user) {
      return <UserForm />
  }

  return (
    <Router>
      <LoginContext.Provider value={{ memberPiece, setMemberPiece, currUserPiece, setCurrUserPiece, 
        isStaked, setIsStaked, isGameOver, setIsGameOver }}>
        <Web3ReactProvider getLibrary={getLibrary}>
          <Connection />          
            <Switch>
              <Route exact path="/">
                  <Home></Home>
              </Route>
              <Route path="/game/:id">
                  <GameApp />
              </Route>
            </Switch>
        </Web3ReactProvider>
      </LoginContext.Provider>
    </Router>
  )
}